// Added for volume discount widget on 23/04/26 — safe to delete this entire file if removing the module
(function () {

  function initVolumeWidget() {
    document.querySelectorAll('.vd-tier').forEach(function (tier) {
      if (tier.dataset.vdInit) return;
      tier.dataset.vdInit = 'true';

      tier.addEventListener('click', function () {
        const quantity = parseInt(tier.dataset.quantity, 10);
        if (!quantity) return;

        // Mark active tier visually
        const allTiers = tier.closest('.vd-tiers').querySelectorAll('.vd-tier');
        allTiers.forEach(t => t.classList.remove('vd-tier--active'));
        tier.classList.add('vd-tier--active');

        // Update visible quantity input for UX feedback
        const productForm = tier.closest('form[action*="/cart/add"]')
          || tier.closest('[id*="quickadd"], [id*="modal"], [class*="quickadd"], [class*="modal"]')?.querySelector('form[action*="/cart/add"]')
          || document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const qtyInput = productForm.querySelector('.quantity__input, input[name="quantity"]');
          if (qtyInput) qtyInput.value = quantity;
        }

        // Keep global as fallback
        if (window.__vdSetQuantity) {
          window.__vdSetQuantity(quantity);
        }
      });
    });
  }

  initVolumeWidget();

  new MutationObserver(initVolumeWidget).observe(document.body, {
    childList: true,
    subtree: true
  });

})();